import * as types from './mutation-types';
import { SEARCH_PARAMS, PAGING_INFO, SELECTED_ROW } from './state';

export default {
	[types.STATE_INIT]: state => {
		state.searchParams = SEARCH_PARAMS();
		state.pmcPagingInfo = PAGING_INFO();
		state.partCkuInfo = PAGING_INFO();
		state.selectedRow = SELECTED_ROW();
		state.resultList = [];
		state.okReport = [];
		state.ngReport = [];
		state.partCkuList = [];
		state.pmcList = [];

		state.attentionList = [];
		state.okList = []; //결과는 합격인데, 리스트가 다 불량인경우
		state.ngList = []; //결과는 불합격인데, 리스트가 다 합격인경우

		state.isPqyUser = false;

		state.sgrpAllList = [];
		state.lgrpCdList = [];
		state.sgrpCdList = [];
		state.tymaCdList = [];
		state.ipnWayCdList = [];
		state.utmCdList = [];
		state.icrtCdList = [];
		state.indvJgmtCdList = [];
		state.oputStCdList = [];
		state.powQltyCdList = [];
		state.apenCkuCdList = [];
		state.clfcStCdList = [];
		state.cdcnStCdList = [];
		state.partBloCdList = [];
		state.partSrgCdList = [];
		state.ovrlJgmtCdList = [];
	},
	[types.POPUP_INIT]: state => {
		state.pmcList = [];
		state.pmcPagingInfo = PAGING_INFO();
		state.partCkuList = [];
		state.partCkuInfo = PAGING_INFO();
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.SEARCH_PARAM]: (state, { key, value }) => {
		state.searchParams[key] = value;
	},
	[types.SELECTED_ROW]: (state, { key, value }) => {
		state.selectedRow[key] = value;
	},
	[types.ERROR_LIST]: (state, { key, value }) => {
		state[key].push(value);
	},
	[types.ATTENTION_LIST]: (state, newElement) => {
		!state.attentionList.includes(newElement) && state.attentionList.push(newElement);
	},
	[types.PAGING_INFO]: (state, { key, value, info }) => {
		state[info][key] = value;
	}
};
